import { Size } from "./Size";
import { Event } from "./Event";
import { Basic } from "./Basic";
import { Color } from "./Color";
import { Position } from "./Position";
import { Animation } from "./Animation";
import { Appearance } from "./Appearance";

export const Components = () => {
  return (
    <>
      <Event />
      <Basic />
      <Size />
      <Position />
      <Appearance />
      <Color />
      <Animation />
    </>
  );
};
